export default __webpack_public_path__ + "static/media/48px_mastercard 1.13d1be19.svg";